// Sim primitives (IMPLEMENTATION §0.1, §2.2). Every number in SimState / SimDefs is an integer.
// M2 fills in the state, commands and systems; M0 only fixes the vocabulary the arch test guards.

/** A JS safe integer (C#: int/long). Documentation alias: the arch test and golden hashes enforce it. */
export type Int = number;

/** Facing on the fixed 7×9 grid. */
export type Dir = 'N' | 'E' | 'S' | 'W';

export interface Cell {
  x: Int;
  y: Int;
}

export function isInt(v: unknown): v is Int {
  return typeof v === 'number' && Number.isSafeInteger(v);
}
